import { ChangeEvent, FC, useState } from 'react'

import { Switch, TextArea, typography } from '@joor/design-system'
import styled from 'styled-components'

import { useUserAnalytics } from 'utils/sdks/userAnalytics'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px;
  background: var(--color-secondary-100);
  border-radius: var(--size-border-radius-small);
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Title = styled.div`
  ${typography.alpha.primaryActive.subtitle3};
  font-weight: var(--font-weight-semibold);

  &.hidden-text-area {
    color: var(--color-primary-400);
  }
`

const StyledTextArea = styled(TextArea)`
  resize: none;
`

type Props = {
  value: string
  title?: string
  placeholder?: string
  onChange?: (value: string) => void
}

export const MessageTextArea: FC<Props> = ({
  value,
  title = 'Add a personalized message',
  placeholder = 'Write a message',
  onChange,
}) => {
  const [isTextAreaVisible, setIsTextAreaVisible] = useState(false)
  const { trackEvent } = useUserAnalytics()

  return (
    <Container>
      <Header>
        <Title className={!isTextAreaVisible ? 'hidden-text-area' : ''}>
          {title}
        </Title>
        <Switch
          id="showTextArea-switch"
          onChange={(): void => {
            setIsTextAreaVisible(!isTextAreaVisible)
            trackEvent(
              'Order_Review_Share_Modal_(Add_Personalized_Message_Toggle)',
            )
          }}
        />
      </Header>
      {isTextAreaVisible && (
        <StyledTextArea
          value={value}
          placeholder={placeholder}
          onFocus={() =>
            trackEvent(
              'Order_Review_Share_Modal_(Add_Personalized_Message_Field)',
            )
          }
          onChange={(event: ChangeEvent<HTMLTextAreaElement>): void =>
            onChange?.(event.target.value)
          }
        />
      )}
    </Container>
  )
}
